// extracted by mini-css-extract-plugin
export var layoutContainer = "_4s-0";
export var layoutContainerNoRounding = "_4s-6";
export var layoutContainerOpen = "_4s-5";
export var layoutContainerResizing = "_4s-1";
export var mainContent = "_4s-2";
export var resizeDivider = "_4s-3";
export var slidePanel = "_4s-4";